import components from './validators/components/all';

import type { ComponentType } from './validators/fields/ComponentType';

const getComponentDefinition = (type: ComponentType) => {
    return components[type];
};

export { getComponentDefinition };
